import { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import './AuthPage.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../../supabaseClient';

const AuthPage = () => {
  const [mode, setMode] = useState('login'); // 'login' | 'signup' | 'forgot'
  const [authMessage, setAuthMessage] = useState('');
  const [authError, setAuthError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const requestedMode = params.get('mode');
    if (requestedMode && ['login', 'signup', 'forgot'].includes(requestedMode)) {
      setMode(requestedMode);
    }
  }, [location.search]);

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        navigate('/reset-password');
        return;
      }
      if (session) {
        navigate('/user-dashboard');
      }
    });

    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) {
        // If the URL has recovery tokens, let PASSWORD_RECOVERY event or reset-password route take precedence
        const hash = window.location.hash || '';
        if (hash.includes('type=recovery')) {
          navigate('/reset-password');
          return;
        }
        navigate('/user-dashboard');
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [navigate]);

  const switchToLogin = (message = '') => {
    if (typeof message === 'string' && message) {
      setAuthMessage(message);
    } else {
      setAuthMessage('');
    }
    setAuthError('');
    setMode('login');
  };

  const getHeading = () => {
    if (mode === 'login') return 'Sign In to Your Account';
    if (mode === 'signup') return 'Create Your Free Account';
    return 'Reset Your Password';
  };

  return (
    <div className="auth-container ai-gradient-header">
      <div className="auth-box">
        <h2>{getHeading()}</h2>

        {authError && <div className="auth-error">{authError}</div>}
        {authMessage && <div className="auth-message">{authMessage}</div>}

        {mode === 'login' && (
          <LoginForm
            setAuthError={setAuthError}
            clearMessages={() => {
              setAuthMessage('');
              setAuthError('');
            }}
            onForgotPasswordClick={() => {
              setAuthMessage('');
              setAuthError('');
              setMode('forgot');
            }}
          />
        )}

        {mode === 'signup' && (
          <SignupForm
            switchToLogin={switchToLogin}
            setAuthError={setAuthError}
            setAuthMessage={setAuthMessage}
          />
        )}

        {mode === 'forgot' && (
          <ForgotPasswordForm
            switchToLogin={switchToLogin}
            setAuthError={setAuthError}
            setAuthMessage={setAuthMessage}
          />
        )}

        {mode !== 'forgot' && (
          <button
            onClick={() => {
              setAuthMessage('');
              setAuthError('');
              setMode(mode === 'login' ? 'signup' : 'login');
            }}
            className="toggle-button"
          >
            {mode === 'login'
              ? "Don't have an account? Sign Up"
              : 'Already have an account? Sign In'}
          </button>
        )}
      </div>
    </div>
  );
};

export default AuthPage;